<template>
  <el-tooltip class="item" effect="dark" placement="right">
    <i class="el-icon-question prompt"></i>
    <div slot="content" class="content">
      <p style="font-weight: bold">密码规则</p>
      <p>（1）长度必须为8-20位。</p>
      <p>（2）必须包含大小写字母、数字和特殊字符。</p>
      <p>（3）特殊字符包括： ! @ # $ % ^ & * ( ) _ + - = [ ] { } ; ' : " , . &lt; &gt; / ?  </p>
      <p>（4）不能包含与用户名相同的内容。</p>
      <p>（5）不能包含三位及以上连续的字母或数字，例如 “abc、cba、123” 等</p>
      <p>（6）不能包含三位及以上相同的字母或数字，例如 “aaa、111” 等</p>
      <p>（7）不能包含键盘上连续的三位及以上字母，例如 “qwe、ewq” 等</p>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'OtsPasswordTooltip',
}
</script>

<style lang='less' scoped>
.prompt {
  position: absolute;
  right: -24px;
  bottom: 12px;
  z-index: 999;
  font-size: 16px;
}

.content {
  line-height: 24px; 
  font-size: 13px; 
  font-family: "PingFangSC-Regular, PingFang SC";
}
</style>